import { t } from 'ttag';
import EnLanguageIcon from '../../icons/en-language-icon.svg';
import EsLanguageIcon from '../../icons/es-language-icon.svg';
import TrLanguageIcon from '../../icons/tr-language-icon.svg';
import type { LanguageIconProps } from './languageIcon.types';
import './languageIcon.scss';

/**
 * Renders the flag icon of a language code in the sidebar language menu. Switches between the English, Spanish and Turkish icons and returns null for any other code.
 *
 * @param languageCode - The language code whose icon is rendered.
 * @returns The language icon element, or null for an unsupported code.
 */
const LanguageIcon = ({ languageCode }: LanguageIconProps) => {
  switch (languageCode) {
    case 'en': {
      return <img className="language-icon" src={EnLanguageIcon} alt={t`Language icon`} />;
    }
    case 'es': {
      return <img className="language-icon" src={EsLanguageIcon} alt={t`Language icon`} />;
    }
    case 'tr': {
      return <img className="language-icon" src={TrLanguageIcon} alt={t`Language icon`} />;
    }
    default: {
      return null;
    }
  }
};

export default LanguageIcon;
